module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Away_With_the_Fairies2#Contents-A"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This book is dedicated to my dearest twin, Jenny Pausacker."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("With thanks as always to A.W.G., J.S.L.G., A.D.P.,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("D.L.J.G., J.P., and S.T. They know who they are…"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("And to Jenny Darling, proprietor of Wee Nooke.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f779d04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Away_With_the_Fairies-3.vue
// module id = 69
// module chunks = 0